import { Link } from 'react-router-dom';
import type { Article } from '@/types';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeader from '@/components/feature/SectionHeader';
import { formatViews } from '@/utils/format';

export default function LatestNews({ latest, ranking }: { latest: Article[]; ranking: Article[] }) {
  return (
    <section className="w-full px-4 md:px-8 pb-10 md:pb-12">
      <SectionHeader
        title="最新资讯"
        subtitle="刚刚发生、正在发酵的吃瓜动态"
        icon="ri-newspaper-line"
        moreTo="/category/hot-news"
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
        <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {latest.map((item) => (
            <ArticleCard key={item.id} article={item} />
          ))}
        </div>

        <aside className="lg:col-span-1">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 sticky top-20">
            <h3 className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2 mb-4">
              <span className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
                <i className="ri-fire-line text-sm" />
              </span>
              热吃瓜榜
            </h3>
            <ol className="space-y-1">
              {ranking.map((item, i) => (
                <li key={item.id}>
                  <Link
                    to={`/detail/${item.id}`}
                    className="group flex gap-3 py-3 border-b border-background-100 last:border-0"
                  >
                    <span
                      className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs font-bold ${
                        i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="min-w-0">
                      <span className="block text-sm text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {item.title}
                      </span>
                      <span className="block mt-1 text-xs text-foreground-400 flex items-center gap-1">
                        <i className="ri-eye-line" /> {formatViews(item.views)} 阅读
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </aside>
      </div>
    </section>
  );
}